import { useContext } from 'react';
import { CopyContext } from '../../context/copy-context.js';
export const useCopy = () => {
    const { copy } = useContext(CopyContext);
    return copy;
};
//# sourceMappingURL=use-copy.js.map